module.exports = __webpack_public_path__ + "img/brand_4.0dd1d055.png";